/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CashierPurchasedCostumePageService";
const log: any = LoggerModule.getInstance();

export class CashierPurchasedCostumePageService {
  private static instance: CashierPurchasedCostumePageService;
  private vapp: VApplication;
  private boxDetails: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): CashierPurchasedCostumePageService {
    if (!CashierPurchasedCostumePageService.instance) {
      CashierPurchasedCostumePageService.instance =
        new CashierPurchasedCostumePageService(props);
    }
    return CashierPurchasedCostumePageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public getBoxDetails() {
    return this.boxDetails;
  }
  private setBoxDetails(data: any) {
    this.boxDetails = data;
  }

  public async getBoxes(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getBoxes(arg);
    this.setBoxDetails(content?.data);
    return content;
  }

  public async createPayTx(arg: any) {
    let content: any = {};
    let payDetails: any;
    const agent = getAgent();
    payDetails = this.getBoxDetails();
    content = await agent.createPayTx({ ...arg, ...payDetails });
    return content;
  }

  public async getInvoicePdf(payload: any) {
    let content: any = {};
    const agent = getAgent();

    content.invoiceLink = await agent.getInvoicePdf(payload);

    return content;
  }

  public async onMarkAsDelivered(args: any) {
    const agent = getAgent();
    return agent.MarkAsDelivered(args);
  }
}
